import { render } from "./CommessaForm.vue?vue&type=template&id=62a33ba7"
import script from "./CommessaForm.vue?vue&type=script&lang=js"
export * from "./CommessaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__